import React from 'react';

import { Modal, ModalContent, ModalHeader, ModalTitle } from '@epoch-ui/components/Modal/modal';
import { useEditableEvent } from '@event-editor/hooks/useEditableEvent';
import { formatDateInTimezone, guessTimezone } from 'utils/dateTimeUtils';
import { SlackButton, SlackPreview } from '@epoch-components/SlackPreview';

interface SlackPreviewReminderModalProps extends React.ComponentPropsWithoutRef<typeof Modal> {
  message: string;
}

/**
 * Display a preview of a slack message.
 * Note: Currently intended only for slack reminders.
 * - Looking to support other previews or update name of this component to be reminder-specific
 */
export const SlackPreviewReminderModal: React.FC<SlackPreviewReminderModalProps> = ({
  message,
  ...modalProps
}) => {
  const event = useEditableEvent();

  // Get current time formatted in user's timezone
  const currentTime = formatDateInTimezone(new Date(), guessTimezone(), 'H:mm A');

  return (
    <Modal {...modalProps}>
      <ModalContent className="tw-max-w-[688px]">
        <ModalHeader>
          <ModalTitle>Reminder Preview</ModalTitle>
        </ModalHeader>

        <SlackPreview timestamp={currentTime}>
          <SlackPreview.Message markdownContent={message} />
          <SlackPreview.Divider />
          <SlackPreview.EventDetails event={event} />
          <SlackPreview.Actions>
            <SlackButton variant="primary">Going</SlackButton>
            <SlackButton variant="default">Maybe</SlackButton>
            <SlackButton variant="danger">Not going</SlackButton>
          </SlackPreview.Actions>
        </SlackPreview>
      </ModalContent>
    </Modal>
  );
};
